import React, {FC} from 'react';

import './styles.scss';

interface Props {
  home: {
    name?: string;
    value: string;
  };
  away: {
    name?: string;
    value: string;
  };
  middle?: {
    name?: string;
    value: string;
  };
  footer?: string;
}

const BarChart: FC<Props> = ({home, away, middle, footer}: Props) => {
  return (
    <div className="BarChart">
      <div className="BarChart__bar BarChart__bar--home" style={{height: `${home.value}px`}}>
        <span className="BarChart__value">{home.value}%</span>
        {home.name && <span className="BarChart__label">{home.name}</span>}
      </div>
      {middle && (
        <div className="BarChart__bar BarChart__bar--middle" style={{height: `${middle.value}px`}}>
          <span className="BarChart__value">{middle.value}%</span>
          {middle.name && <span className="BarChart__label">{middle.name}</span>}
        </div>
      )}
      <div className="BarChart__bar BarChart__bar--away" style={{height: `${away.value}px`}}>
        <span className="BarChart__value">{away.value}%</span>
        {away.name && <span className="BarChart__label">{away.name}</span>}
      </div>
      {footer && <span className="BarChart__footer">{footer}</span>}
    </div>
  );
};

export default BarChart;
